import React from 'react';
import { X, Phone, Mail, MapPin, Instagram } from 'lucide-react';

const TeamProfileModal = ({ member, onClose }) => {
  const phone = member.mobile || member.phone || '';
  const role = member.position_title || member.role || '';
  const bio = member.description || member.bio || '';
  const instagramUrl = member.instagram
    ? (member.instagram.startsWith('http') ? member.instagram : `https://instagram.com/${member.instagram.replace('@','')}`)
    : '';
  const tiktokUrl = member.tiktok
    ? (member.tiktok.startsWith('http') ? member.tiktok : `https://tiktok.com/@${member.tiktok.replace('@','')}`)
    : '';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content team-profile-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="team-profile-header">
          {member.image ? (
            <img src={member.image} alt={member.name} style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover', border: '3px solid var(--brand-primary)' }} />
          ) : (
            <div className="team-profile-avatar">{member.name?.charAt(0)}</div>
          )}
          <h2 className="team-profile-name">{member.name}</h2>
          {role && <p className="team-profile-role">{role}</p>}
        </div>

        {bio && (
          <div className="team-profile-bio">
            <p>{bio}</p>
          </div>
        )}

        <div className="team-profile-details">
          {phone && (
            <div className="profile-detail-item">
              <div className="detail-icon"><Phone size={20} /></div>
              <div className="detail-content">
                <span className="detail-label">Phone</span>
                <a href={`tel:${phone}`} className="detail-value">{phone}</a>
              </div>
            </div>
          )}

          {member.email && (
            <div className="profile-detail-item">
              <div className="detail-icon"><Mail size={20} /></div>
              <div className="detail-content">
                <span className="detail-label">Email</span>
                <a href={`mailto:${member.email}`} className="detail-value">{member.email}</a>
              </div>
            </div>
          )}

          {member.location && (
            <div className="profile-detail-item">
              <div className="detail-icon"><MapPin size={20} /></div>
              <div className="detail-content">
                <span className="detail-label">Location</span>
                <span className="detail-value">{member.location}</span>
              </div>
            </div>
          )}
        </div>

        <div className="team-profile-actions">
          {phone && (
            <button className="btn-primary btn-call" onClick={() => window.location.href = `tel:${phone}`}>
              <Phone size={20} /> Call Now
            </button>
          )}
          {member.email && (
            <button className="btn-secondary btn-email" onClick={() => window.location.href = `mailto:${member.email}`}>
              <Mail size={20} /> Send Email
            </button>
          )}
        </div>

        {(instagramUrl || tiktokUrl) && (
          <div className="team-profile-social">
            <h4>Follow on Social Media</h4>
            <div className="social-buttons">
              {instagramUrl && (
                <button className="social-btn instagram-btn" onClick={() => window.open(instagramUrl, '_blank')}>
                  <Instagram size={24} />
                  <span>Instagram</span>
                </button>
              )}
              {tiktokUrl && (
                <button className="social-btn tiktok-btn" onClick={() => window.open(tiktokUrl, '_blank')}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                  <span>TikTok</span>
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamProfileModal;
